import Vue from "vue";

import PollQuestion from "./PollQuestionWrapper.vue";

export function load() {
    const selector = "poll-question";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(PollQuestion, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
